import { makeStyles } from '@material-ui/core/styles';
import { lightBlue } from '@material-ui/core/colors';

export const styles = makeStyles((theme) => ({
  root: {
    // height: '15px !important'
    '& .MuiSvgIcon-root': {
      width: '15px',
      height: '15px',
    },
    //width: '240px',
  },
  optionsName: {
    width: '100%',
    marginBottom: '5px !important',
  },
  paperDesign: {
    minWidth: '300px',
  },
  selectedOptionsChip: {
    backgroundColor: '#ccc',
    maxWidth: '75px',
    height: '20px',
  },
  inputControl: {
    height: '5px !important',
    padding: '0px !important',
  },
  dateControl: {
    '& .MuiOutlinedInput-adornedStart': {
      padding: '0px 10px 0px 2px',
    },
    '& .MuiIconButton-root': {
      padding: '0px 0px 0px 2px',
    },
    '& .MuiSvgIcon-root': {
      height: '15px !important',
      padding: '0px !important',
    },
    padding: '0px !important',
  },
}), { name: 'filter-dropdown' });
